import styled from 'styled-components';

export const Button = styled.button`
  background: transparent;
  border-radius: 3px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 1em;
  padding: 11px 30px;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
  background-color: var(--primary-color);
  border-radius: 50px;
  border: 0;
  margin: 15px !important;
  min-height: 40px;
  width: 160px;
  font-weight: bold;
  // font-size: 16px
`;
export const Paragraph = styled.p`
  margin: 0 1em;
`;

export const MainContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NavBar = styled.div`
  margin: 10px;
  font-size: 25px;
  color: var(--primary-color);
`;

export const Image = styled.img``;
